import { memo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { SimpleTable } from 'cng-common/components/simpleTable'

import styles from './ContactDetailsBasic.module.scss'

interface Props {
  contact: IContact
}

export const ContactDetailsBasic = memo<Props>(({ contact }) => (
  <div className={styles.contactDetailsWrapper}>
    <SimpleTable className={styles.contactDetailsTable}>
      <SimpleTable.HeaderRow className={styles.contactDetailsTableHeaderRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Basic
        </SimpleTable.HeaderCell>
      </SimpleTable.HeaderRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Learner id
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.learnerId || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Gender
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.salutation || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          First name
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.firstName || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Last name
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.lastName || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          HP roles
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.hpRoles.join(', ') || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Seniority
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.seniority || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Job function
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.primaryJobRole.join(', ') || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
      <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
        <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
          Location id
        </SimpleTable.HeaderCell>
        <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
          {contact.locationId || '-'}
        </SimpleTable.BodyCell>
      </SimpleTable.BodyRow>
    </SimpleTable>
  </div>
))
